export const MIN_PASSWORD_LENGTH = 8;

/**
 * @param {string} password
 * @param {string} confirmPassword
 * @returns {{ valid: boolean, errors: string[] }}
 */
export function validatePasswordPair(password, confirmPassword) {
  const errors = [];

  if (!password) {
    errors.push('Enter a new password.');
  } else if (password.length < MIN_PASSWORD_LENGTH) {
    errors.push(`Password must be at least ${MIN_PASSWORD_LENGTH} characters.`);
  }

  if (password && confirmPassword && password !== confirmPassword) {
    errors.push('Passwords do not match.');
  }

  return {
    valid: errors.length === 0 && Boolean(password) && password === confirmPassword,
    errors,
  };
}

/**
 * @param {'platform_owner'|'platform_admin'|'super_admin'|'owner'|'specialist'|string} actorRole
 * @param {string} [actorAgencyId]
 * @param {string} [drawerAgencyId]
 * @returns {boolean}
 */
export function canActorManagePasswords(actorRole, actorAgencyId, drawerAgencyId) {
  if (['platform_owner', 'platform_admin', 'super_admin'].includes(actorRole)) {
    return true;
  }
  if (['owner', 'specialist'].includes(actorRole)) {
    return Boolean(actorAgencyId && drawerAgencyId && actorAgencyId === drawerAgencyId);
  }
  return false;
}

/**
 * @param {string} targetRole
 * @param {string} actorRole
 * @returns {boolean}
 */
export function canActorManageTargetPassword(targetRole, actorRole) {
  if (['platform_owner', 'super_admin'].includes(targetRole)) {
    return ['platform_owner', 'super_admin'].includes(actorRole);
  }
  return true;
}

/**
 * @param {string} actorRole
 * @returns {'admin-ops'|'portal-staff'}
 */
export function passwordApiScope(actorRole) {
  if (['platform_owner', 'platform_admin', 'super_admin'].includes(actorRole)) {
    return 'admin-ops';
  }
  return 'portal-staff';
}
